// import React from 'react'

// const Consulta = props => {
//     return <></>
// }

// export default Consulta

import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { Formik, Form } from "formik";
import Yup, { validaData, periodoData } from '../../../../util/Validacoes';
import { mostrarToast } from '../../../../components/Toasts'
import { useParams } from "react-router-dom";
import { ModalDuasOpcoes } from '../../../../components/Modais';
import { get, salvar, validar } from '../../../../util/AcessoApi'
import { HeaderCadastro } from '../../../../components/Headers'
import { Link } from 'react-router-dom'
import { InputPadrao, InputDatePicker, TextArea } from '../../../../components/Inputs'
import { InputUnidadeMedida, InputCor, InputSimNao, InputTipoProdutoBtn } from '../../../../components/InputsAutoComplete'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens } from '../../../../util/Utilitarios'
import '../../../../assets/css/icones/iconsmind/style.css'
import Atalho from '../../../../util/Atalho'

const CadastroEscalador = (props) => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')
    const refTipoProduto = useRef();

    const [validacao] = useState(Yup.object({
        codigo_barras: Yup.string().nullable().required().test('Código de Barras', 'Campo numérico!', function (value) { return /^[0-9-*#+]+$/.test(value) }),
        produto_unidade_medida: Yup.string().nullable().required(),
        produto_tipo: Yup.string().nullable().required(),
        descricao: Yup.string().nullable().required(),
        observacao: Yup.string().nullable().max(200)
    }))

    // const ValidarSubmit = (values, resetForm) => {
    //     setSalvando(true)
    //     validar('/estoque/escaladorVerificacao', values, () => Submit(values, resetForm), (e) => {
    //         setShowModalValidacao(true)
    //         setMensagemModal(e.response.data.alertas[0])
    //         setSalvando(false)
    //     })
    // }

    const funcaoAposSim = (formik) => {
        Submit(formik.values, formik.resetForm)
    }

    const manter = ['produto_tipo']
    

    const Submit = (values, propsFormik) => {
        setSalvando(true)

        salvar(
            values,
            '/estoque/produto',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)

                if (salvarENovo) {
                    propsFormik.resetForm({})
                    manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                    setSalvando(false)
                    setSalvarENovo(false)
                    document.getElementById("codigo_barras").focus();
                }
                else
                    props.history.push('/estoque/produto/consulta')
            },
            () => {
                setSalvando(false)
            })
    }

    useEffect(() => {
        if (id) {
            Promise.resolve(get(`/estoque/produto/${id}`)).then(val => {
                if (!val.data_registro)
                    props.history.push('/estoque/produto/consulta')

                setValoresIniciais(val)
            })
        } else {
            setValoresIniciais({
                codigo_barras: null,
                produto_tipo: "",
                descricao: "",
                produto_unidade_medida: null,
                peso: null,
                tamanho: null,
                produto_cor: null,
                observacao: null,
                estoque_min: null,
                estoque_max: null,
                bloqueado: { value: 'false', label: 'Não' }
            })
        }

    }, [id])

    return (<Formik
        initialValues={valoresIniciais}
        validationSchema={validacao}
        enableReinitialize={true}
        onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
        {propsFormik => (<Form>
            <div className={props.modal ? '' : 'card mb-20'}>
                <div className={props.modal ? '' : 'card-body'}>
                    <div className='row'>
                        <InputPadrao label="Id" name="id" type="hidden" placeholder="Id" obrigatorio={true} />

                        <InputPadrao label="Código de Barras" name="codigo_barras" type="text" placeholder="Código de Barras" tamanho="col-xl-3 col-lg-3 col-md-6" id={'codigo_barras'} obrigatorio={true} autoFocus />

                        <InputTipoProdutoBtn label="Tipo Produto" name="produto_tipo" placeholder="Tipo Produto" propsFormik={propsFormik} obrigatorio={true} tamanho='col-lg-3 col-md-6'
                            salvarENovo={salvarENovo} botaoVisivel ref={refTipoProduto} funcaoAposSalvar={() => {refTipoProduto.current.atualizar()}} />

                        <InputPadrao label="Descrição" name="descricao" type="text" placeholder="Descrição" tamanho="col-lg-6 col-md-12" obrigatorio={true} />

                        <InputUnidadeMedida label="Unidade Medida" name="produto_unidade_medida" placeholder="Unidade Medida" propsFormik={propsFormik} obrigatorio={true} tamanho='col-xl-2 col-lg-3 col-md-4'
                            salvarENovo={salvarENovo} />

                        <InputPadrao label="Peso" name="peso" type="number" placeholder="Peso" tamanho="col-xl-1 col-lg-2 col-md-4" />

                        <InputPadrao label="Tamanho" name="tamanho" type="number" placeholder="Tamanho" tamanho="col-xl-1 col-lg-2 col-md-4" />

                        <InputPadrao label="Unidades" name="unidades" type="number" placeholder="Unidades" tamanho="col-xl-2 col-lg-2 col-md-4" />

                        <InputCor label="Cor" name="produto_cor" placeholder="Cor" propsFormik={propsFormik} tamanho='col-xl-2 col-lg-2 col-md-3'
                            salvarENovo={salvarENovo} />

                        <InputPadrao label="Estoque Mínimo" name="estoque_min" type="number" placeholder="Estoque Mínimo" tamanho="col-xl-2 col-lg-3 col-md-4" />

                        <InputPadrao label="Estoque Máximo" name="estoque_max" type="number" placeholder="Estoque Máximo" tamanho="col-xl-2 col-lg-3 col-md-4" />

                        <InputSimNao label="Bloqueado" name="bloqueado" placeholder="Bloqueado" propsFormik={propsFormik} tamanho='col-lg-2 col-md-3'
                            salvarENovo={salvarENovo} isClearable={false} />

                        <TextArea label='Observação' name='observacao' type='text' placeholder='Observação' tamanho='col-xl-6 col-lg-7 col-md-12' />

                        <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                    </div>
                </div>
            </div>
            <div className='separator mt-40 mb-5'></div>
            <div className='direita container-botoes mb-3 group-salvar-novo'>
                <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                {!id && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
            </div>
            <ModalDuasOpcoes showModal={showModalValidacao} setShowModal={setShowModalValidacao} funcaoOpcao2={() => funcaoAposSim(propsFormik)} funcaoOpcao1={() => setSalvando(false)}
                esconderFechar mensagem={mensagemModal}
                textoOpcao1={'Cancelar'}
                classeOpcao1={'btn-sm btn-primary-modal simples'}
                textoOpcao2={'Continuar'} />
        </Form>)}
    </Formik>);
}

const Cadastro = (props) => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <Link to={'#'}>Estoque</Link>,
        () => <Link className="link-active" to={'/estoque/produto/consulta'}>Produto</Link>,
    ]
    return (<>
        <HeaderCadastro titulo={"Cadastro de Produto"} link={links} />
        <CadastroEscalador {...props} />
    </>
    )
}
export { CadastroEscalador }
export default Cadastro
